import { render, staticRenderFns } from "./PopupFloatingFooter.vue?vue&type=template&id=5f802705&scoped=true"
import script from "./PopupFloatingFooter.vue?vue&type=script&lang=js"
export * from "./PopupFloatingFooter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f802705",
  null
  
)

export default component.exports